import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './Carousel';
import { Card, CardContent } from './Card';
const REVIEWS = [{
  name: 'Michael T.',
  location: 'Norman, OK',
  text: 'Cockrell Custom Repairs fixed our well pump quickly when we lost water pressure. They were professional, fast, and the price was exactly what they quoted. Highly recommend!',
  service: 'Well Pump Repair'
}, {
  name: 'Sarah J.',
  location: 'Blanchard, OK',
  text: 'We had a major leak under our sink and they came out the same day. Fixed it quickly and even checked our other fixtures. True professionals.',
  service: 'Plumbing Repair'
}, {
  name: 'David R.',
  location: 'Moore, OK',
  text: 'Showed up on time, worked efficiently, and the carpentry work speaks for itself. Best home repair service I have used in Oklahoma. Highly recommend these guys.',
  service: 'Home Improvement'
}, {
  name: 'Amanda L.',
  location: 'Edmond, OK',
  text: 'They handle all the general repairs for our property. Always reliable and they do great work. We trust them with everything from plumbing to drywall.',
  service: 'General Repairs'
}];
export function Reviews() {
  return <section id="reviews" className="py-24 bg-slate-50 border-y border-slate-200 overflow-hidden" data-id="element-171">
      <div className="container mx-auto px-4" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="font-display text-4xl md:text-5xl text-slate-900 uppercase tracking-wide mb-4" data-id="element-174">
            Customer <span className="text-accent" data-id="element-175">Reviews</span>
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-176">
            Do not just take our word for it. See what your neighbors are saying
            about our repair services.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative px-12" data-id="element-177">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-178">
            <CarouselContent className="-ml-4" data-id="element-179">
              {REVIEWS.map((review, index) => <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3" data-id="element-180">
                  <Card className="bg-white border-slate-200 h-full relative overflow-hidden group shadow-sm" data-id="element-181">
                    <div className="absolute -right-4 -bottom-4 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-182">
                      <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-183">
                        <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="#1d3a63" data-id="element-184" />
                      </svg>
                    </div>
                    <CardContent className="p-6 flex flex-col h-full relative z-10" data-id="element-185">
                      <div className="flex gap-1 mb-4" data-id="element-186">
                        {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-accent text-accent" data-id="element-187" />)}
                      </div>
                      <Quote className="h-8 w-8 text-accent/20 mb-4" data-id="element-188" />
                      <p className="text-slate-700 mb-6 flex-grow italic" data-id="element-189">
                        "{review.text}"
                      </p>
                      <div className="mt-auto border-t border-slate-100 pt-4" data-id="element-190">
                        <p className="font-bold text-slate-900" data-id="element-191">
                          {review.name}
                        </p>
                        <div className="flex justify-between items-center mt-1" data-id="element-192">
                          <p className="text-sm text-slate-500" data-id="element-193">
                            {review.location}
                          </p>
                          <span className="text-xs font-bold text-accent uppercase tracking-wider bg-slate-50 px-2 py-1 rounded border border-slate-100" data-id="element-194">
                            {review.service}
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="bg-white border-slate-200 text-slate-600 hover:bg-accent hover:text-white hover:border-accent -left-4 md:-left-12" data-id="element-195" />
            <CarouselNext className="bg-white border-slate-200 text-slate-600 hover:bg-accent hover:text-white hover:border-accent -right-4 md:-right-12" data-id="element-196" />
          </Carousel>
        </div>
      </div>
    </section>;
}